const optionValueBlock = document.querySelector(".option-value-block");
const optionSelectValues = document.querySelectorAll(".option-select");
const optionValues = document.querySelectorAll(".option-value");

optionValueBlock.addEventListener("click", function(e) {
    const clicked = e.target.closest(".option-value");
    if (clicked) {
        const value = clicked.getAttribute('data-value');
        const optionName = clicked.getAttribute('data-option');
        const selectElement = document.querySelector('select[name="id"]');
        const options = selectElement.querySelectorAll('option');
        optionValues.forEach( ov => ov.classList.remove("active") );
        clicked.classList.add("active");
        options.forEach(option => {
            if (option.getAttribute('data-variant-value') === value) {
                option.setAttribute('selected', 'selected');
            } else {
                option.removeAttribute('selected');
            }
        });

        const event = new Event('change');
        selectElement.dispatchEvent(event);
    }
});
